import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: (theme) => ({
    '& > div': {
      height: '750px',
      borderRadius: '20px',
      overflow: 'hidden',
      border: theme.palette.mode === 'light' ? `1px solid ${theme.palette.grey[800]}` : ``,
    },
    '.ms-FocusZone': {
      borderColor: 'divider',
      borderBottomWidth: '1px',
      borderBottomColor: 'divider',
      borderBottomStyle: 'solid',
    },
    '.rooster': {
      borderTop: `1px solid ${theme.palette.grey[800]}`,
      background: `inherit !important`,
      width: '100%',
      height: 'calc(100% - 44px)',
      overflowY: 'auto',
      '::-webkit-scrollbar-track': {
        background: '#777777',
      },

      '::-webkit-scrollbar-thumb': {
        background: '#555555',
      },

      '::-webkit-scrollbar-thumb:hover': {
        background: '#444444',
      },
      outline: 'none',
    },
    '.error-text': {
      color: theme.palette.error.main,
      fontFamily:
        'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji"',
      fontWeight: 400,
      fontSize: '0.65625rem',
      lineHeight: '1.66',
      textAlign: 'left',
      marginTop: '3px',
      marginRigt: '14px',
      marginBottom: 0,
      marginLeft: '14px',
    },
  }),
});

export default useSx;
